module.exports = __webpack_public_path__ + "static/img/10005 (4).d943d80.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (4).webp
// module id = eFv0
// module chunks = 14